// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 929 ? "babylon" : chunkId) + "." + {"685":"f9604f8f","762":"c1b40730","929":"ec958f8a"}[chunkId] + ".chunk.js";
};